export const QUIT_CONFIRMATION_WINDOW_MS = 3_000;

export type QuitShortcutAction = 'arm' | 'quit';

export function decideQuitShortcut({
  armedAtMs,
  nowMs,
  windowMs = QUIT_CONFIRMATION_WINDOW_MS,
}: {
  armedAtMs: number | null;
  nowMs: number;
  windowMs?: number;
}): { action: QuitShortcutAction; armedAtMs: number | null } {
  const isArmed =
    armedAtMs !== null && nowMs >= armedAtMs && nowMs - armedAtMs <= windowMs;

  if (isArmed) {
    return { action: 'quit', armedAtMs: null };
  }

  return { action: 'arm', armedAtMs: nowMs };
}

export function quitShortcutLabel(platform: string): string {
  return platform === 'darwin' ? '⌘Q' : 'Ctrl+Q';
}

export function createQuitShortcutGate({
  quit,
  notify,
  now = Date.now,
  platform,
}: {
  quit: () => void;
  notify: (shortcut: string) => void;
  now?: () => number;
  platform: string;
}): {
  requestQuit: (request: { triggeredByAccelerator: boolean }) => void;
} {
  let armedAtMs: number | null = null;

  return {
    requestQuit({ triggeredByAccelerator }) {
      if (!triggeredByAccelerator) {
        armedAtMs = null;
        quit();

        return;
      }

      const decision = decideQuitShortcut({
        armedAtMs,
        nowMs: now(),
      });

      armedAtMs = decision.armedAtMs;

      switch (decision.action) {
        case 'quit':
          quit();

          return;
        case 'arm':
          notify(quitShortcutLabel(platform));

          return;
        default: {
          const unreachable: never = decision.action;

          return unreachable;
        }
      }
    },
  };
}
